// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__index__abMzP","navigation":"navigation__index__tM6fQ","content":"content__index__Sf6CO","noSideNav":"noSideNav__index__vFqHL"};